import { InvitationDetailsInfo } from "@modules/sharedCoach/components/invitationDetailsInfo"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { SidebarNavigatorParams } from "@modules/sidebar/sidebarTypes"

export const useInvitationSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()

  const navigateToInvitationDetailsInfo = ( args: SidebarNavigatorParams) => {
    sidebarNavigateTo({
      content: <InvitationDetailsInfo  />,
      ...args,
    })
  }

  return { navigateToInvitationDetailsInfo }
}
